export const GRAPHQL_VARIABLES = {
  record: {
    firstName: 'John',
    lastName: 'SUN'
  },
  filter: {
    _id: '5fbdb1a50c228f35dd575a37'
  }
};

export const QUERY = `
mutation UpdateUserInfo($record: UpdateOneusersInput!) {
    updateUserInfo(record: $record, filter: {}) {
        recordId
        record {
            firstName
            lastName
            companyIds
            jobTitle
            defaultCompany
            email
            bookipiUser
            googleId
            appleId
            phoneNumber
            language
            timezone
            hasSignature
            verified
            lastLoginAt
            locale
            _id
            updatedAt
            createdAt
            hash
            salt
            isPhoneVerified
            phoneCountryCode
            companies {
              name
              categoryCode
              address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
              }
              email
              bookipiCompany
              phoneNumber
              website
              businessType
              businessName
              description
              ABN
              ACN
              industry
              bankDetails {
                bankName
                accountName
                accountNo
                routingNumber
                ownershipType
                accountType
              }
              individuals {
                documentType
                licenceNumber
                jurisdiction
                additionalDocumentType
                title
                birth
                firstName
                lastName
                ownership
                address {
                    address1
                    address2
                    address3
                    state
                    city
                    zip
                    country
                    _id
                }
                email
                phone
                _id
                driverLicence { url contentType }
                passport { url contentType }
                utilityBill { url contentType }
              }
              monthlyCardValue
              monthlyTransactions
              annualTurnover
              serviceDeliveryDays
              annualCreditTurnover
              averageDeliveryTime
              averageSalesAmount
              hasSignature
              verified
              currency
              payProvider
              _id
              updatedAt
              createdAt
              additionalPrimaryDocument{ url contentType}
              bankStatement{ url contentType}
              payProvider
           }
        }
        error {
            message
        }
    }
}
  `;
